import Heading, { HeadingLevels } from '@/components/atoms/legacy/Heading';
import { ScComponent } from '@/types/interfaces';
import React, { ReactNode } from 'react';

export interface PageHeaderProps extends ScComponent {
  label: string;
  customButton?: ReactNode;
  headingClassName?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  className = '',
  headingClassName = '',
  label,
  customButton,
}) => {
  return (
    <section
      className={`flex flex-wrap items-center justify-between ${className}`}
    >
      <Heading
        className={`mb-[10px] w-full text-h3Regular text-neutral-900 l:mb-0 l:w-auto ${headingClassName}`}
        level={HeadingLevels.H1}
      >
        {label}
      </Heading>
      {customButton}
    </section>
  );
};

export default PageHeader;
